import React, { useState, useRef, useEffect, useContext } from 'react';
import WpAPI from '../../WpApi'
import Cookies from 'js-cookie';
import { useDispatch, ReactReduxContext } from 'react-redux';
// import { Link } from 'react-router-dom';
import { 
    setMembershipData,
    signUp as signupAction,
    updateFinalTargetLink,
    updateUser,
    userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction
} from '../../services/actions/actions';
import { RECAPTCHA_SITE_KEY, EDITOR_ALL_INONE_LINK, DASHBOARD_LINK, LOGIN_LINK, EDITOR_LINK, FORGET_LINK, SITE_DOMAIN, COOKIE_DOMAIN, PAID_SERVICES, MEMBERSHIP, POPUP_TYPES, APP_DOMAIN, COVERLETTER_EXPERIENCE, REFRESH_LINK, QUICK_EDITOR, TP_REVIEW_URL } from '../../constants/constants';
// import { Redirect } from 'react-router';
import { decryptData, removeBodyScroll, validateEmail, validatePassword } from '../../helper';
import { usePopup } from '../../context/PopupContext';
import { useHistory } from 'react-router-dom';
// import { identify as FullStoryIdentify } from '@fullstory/browser';
import downloadResume from '../../downloadResume';
import { useUser } from '../../context/UserContext';
import { useCoverLetter } from '../../context/CoverLetterContext';

const SignupForm = (props) => {
    const { store } = useContext(ReactReduxContext);
    const [msg, setmsg] = useState('')
    const [email, setemail] = useState('')
    const [password, setpassword] = useState('')
    const [confirmpassword, setconfirmpassword] = useState('')
    const [viewPassword, setViewPassword] = useState(false);
    const [viewConfirmPassword, setViewConfirmPassword] = useState(false);
    const [recaptchaToken, setRecaptchaToken] = useState();
    const [spinner, setSpinner] = useState(false);
    const [loader, setLoader] = useState({download: false, save: false, share: false, print: false, help: false});
    const popupbox = usePopup();
    const history = useHistory();
    const dispatch = useDispatch();
    const type = (window.location.pathname == DASHBOARD_LINK ? 'list' : 'currentResume');
    const entityType = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume");
    const entityName = (entityType == 'resume' ? 'Resume' : 'Cover Letter');
    const { 
        checkMembership, 
        plan,
        user
    } = useUser();

    const { login_action_initiated, } = useCoverLetter();
    useEffect(() => {
        //controlled thru coverletter button action
      login_action_initiated && !validateAndSubmitForm(document.getElementById('submit_button')) && props?.loginInitiationInterrupted &&  props.loginInitiationInterrupted();
  }, [login_action_initiated]);

    const mounted = useRef(false);

    useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    })

    const RedirectPage = () => {
        React.useEffect(() => {
            window.location.href = `${SITE_DOMAIN}/membership/`;
        }, [])
    }
    
    const handleOnClick = e => {
        e.preventDefault();
        //setLoading(true);
        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
                submitData(token);
            });
        });
    }

    useEffect(() => {
        ((id, url) => {
            const isScriptExist = document.getElementById(id);

            if (!isScriptExist) {
                var script = document.createElement("script");
                script.type = "text/javascript";
                script.src = url;
                script.id = id;
                document.body.appendChild(script);
            }
        })("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`)
    }, []);

    const validateAndSubmitForm = (event) => {
        setmsg('');
        let haserror = false,_msg = '';
        let target = event?.hasOwnProperty('target') ? event.target : event
        if(email == '') _msg = 'The Email field is required';
        else if(!validateEmail(email)) _msg = 'Email is not valid';
        else if(password == '')_msg = 'The Password field is required';
        else if(!validatePassword(password))_msg = 'Password must be at least 8 characters long, 1 uppercase, 1 lowercase, 1 special character & 1 number';
        else if(confirmpassword == '')_msg = 'The Confirm Password field is required';
        else if(!validatePassword(confirmpassword))_msg = 'Confirm Password must be at least 8 characters long, 1 uppercase, 1 lowercase, 1 special character & 1 number';
        else if (password !== confirmpassword) _msg = 'The Password and Confirm Password fields must match';

        if(!_msg) {
            target && (target.innerHTML = "Registering..")
            window.grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then(token => {
                //setRecaptchaToken(token);
                submitForm(event, token)
            });
            return true;
        }else{
            setmsg(_msg);
            //Dont update for coverletter
            (props.type == 'coverletter_page') || (target.innerHTML = (props.hasOwnProperty('type') && props.type === 'popup' ? 'Sign Up' : 'Sign Up') )
            return false
        }
    }

    const postSignupHandlers = (res, event) => {
        // call the tracking events post login/signup
        trackingEventsHandler(res)
        // save the resume/coverletter data post login/signup
        saveHandler()
        // load the resumes/coverletters post login/signup
        dataReloadHandler()
        // trigger the last clicked action post login/signup
        lastActionHandler()
        // final actions post login/signup
        finalActionsHandler(event)
    }

    const updateStateUserAndMembership = () => {
        WpAPI.isLoggedIn() && WpAPI.getLoginUserInfo().then(res => {
            dispatch(updateUser(res.data.user))
            const currentAccount = {
                plan: 'pro', 
                lastsync: Math.floor(Date.now() / 1000), 
                has_plan: true,
                plan_has_trial: false,
                plan_status: 'active'
            }
            dispatch(setMembershipData(currentAccount));
        })
    }

    const trackingEventsHandler = (res) => {
        // send data to the FullStory
        // if(ENV == 'prod') fullStoryIdentify(email);
    }

    const saveHandler = () => {
        //const dashboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(entityType == 'resume')
                WpAPI.saveState(store.getState(), true, false)
        }
    }

    const dataReloadHandler = () => {
        //const dashboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(window.location.pathname == '/'){
                if(entityType == 'resume')
                    WpAPI.loadResumesInDashboard(props.setEntities)
                else if(entityType == 'coverletter')
                    WpAPI.loadCoverLettersInDashboard(props.setEntities)
            }
        }
    }

    const lastActionHandler = () => {
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(window.location.pathname == '/'){
                setTimeout(() => {
                    triggerLastAction();
                }, 300);
            }else{
                triggerLastAction();
            }
        }
    }

    const finalActionsHandler = (event) => {
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            props.setShowLoginPopUp(false)
        }else if (props.hasOwnProperty('type') && props.type === 'page') {
            checkMembershipAction()
            window.location.href = '/'
        }else if (props.hasOwnProperty('type') && props.type === 'coverletter_page') {
            // checkMembershipAction()
            // window.location.href = '/coverletter/finalize'
            // props.loginInitiationCompleted();
            props.loginSuccessfullyCompleted()
            // event?.target && (event.target.innerHTML = "Generate Cover Letter")
        }
    }
    const submitForm = (event, token) => {
        dispatch(
            signupAction(
                {
                    //user: 'shashank111' + Math.floor(Math.random() * 10000) + '@gmail.com',
                    //password: 'Stripes39!'
                    user: email,
                    password: password,
                    confirmpassword: confirmpassword,
                    token: token
                }
            )
        ).then(res => {
            WpAPI.linklocalResumeToUser()
            // update user and memberhip data afer a successful signup
            updateStateUserAndMembership()
            return res
        // }).then(res => {
        //     WpAPI.linkLocalCoverLetterToUser(dispatch).then(resp => {
        //         //Called in next FetchActiveResume callback function
        //         // postSignupHandlers(res)
        //     })
        //     return res
        }).then(res => {
            WpAPI.fetchActiveResume(dispatch, () => {
            setmsg(res.msg);
            fireGA4EventOnSignup(res.msg);
            postSignupHandlers(res,event)
            /*
            if (props.hasOwnProperty('type') && props.type == 'popup') {
                WpAPI.saveState(store.getState(), true, false)
                if(window.location.pathname == '/'){
                    WpAPI.loadResumesInDashboard(props.setResumes);
                    setTimeout(() => {
                        triggerLastAction();
                    }, 300);
                }else{
                    triggerLastAction();
                }
                props.setShowLoginPopUp(false);
                if(ENV == 'prod') fullStoryIdentify(email);
            }
            if (props.hasOwnProperty('type') && props.type == 'page') {
                checkMembershipAction();
                if(ENV == 'prod') fullStoryIdentify(email);
                window.location.href = '/';
            }
            */
        })}).catch((e) => {
            setmsg(e)
            props.type == 'coverletter_page' || event.target && (event.target.innerHTML = "Sign Up")
            props.type == 'coverletter_page' && props.loginInitiationInterrupted();
        })
    }

    const enter = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            props?.loginInitiated && props.loginInitiated();//related to coverletter
            if(!validateAndSubmitForm(document.getElementById('submit_button'))) props?.type == 'coverletter_page' && props.loginInitiationInterrupted();
        }
    }

    const checkMembershipAction = (callback = false, params = false, forcechange = true) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
            const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
            if(localStorage.getItem('clickAction') && !downloadOnAllinonePageLoad) localStorage.removeItem('clickAction');
        }, forcechange);
    }

    const download = () => {
        // if(PAID_SERVICES){
        //     store.getState().plan == 'pro' 
        //     ? popupbox.show('download', null, () => downloadResumeHandler()) 
        //     : history.push(MEMBERSHIP);
        // }else{
        //     popupbox.show('download', null, () => downloadResumeHandler()) 
        // }
        /**
         * #775: Any logged in users can download the resume in the text format. 
         * Action: Removed the above code snippet having PAID_SERVICES and plan check.
         * Date: 2023-07-21
         */
        //This is coming from Quick Editor Traditional page. When user clicks the download button.
        const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
        //Bypass plan as pro, pro is free
        if((1 || store.getState().plan == 'pro') && downloadOnAllinonePageLoad){
            history.push(QUICK_EDITOR);
        }else{
            popupbox.show('download', null, () => {
                downloadResumeHandler();
                userCompletesSectionsDownloadsPrintsOrShares();
                localStorage.getItem('downloadOnAllinonePageLoad') && localStorage.removeItem('downloadOnAllinonePageLoad');
            }, {plan: store.getState().plan, entity:{type: entityType, name: entityName }, referrer:'signup'});
        }
    }

    const downloadResumeHandler = () => {
        downloadResume(store.getState(), user, () => { 
            popupbox.close('download');
            popupbox.show('askfor_trustpilot_review', null, () => {
                window.open( TP_REVIEW_URL, '_blank');
            });
            // popupbox.show('downloadcompletionbox', null, () => {
            //     window.location.href = `${APP_DOMAIN}${COVERLETTER_EXPERIENCE}`;
            // });
        }, store.getState().downloadFormat, {type: entityType, name: entityName});
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction(store.getState().resume, type)).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && store.getState().plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && store.getState().plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RT App', el)
            }
        })
    }

    const saveAndNext = () => {
        if (PAID_SERVICES) {
            //Bypass plan as pro, pro is free
            if (1 || store.getState().plan == 'pro') {
                dispatch(updateFinalTargetLink({link: QUICK_EDITOR}));
                setTimeout(() => {
                    history.push(REFRESH_LINK);
                }, 100);
            } else {
                dispatch(updateFinalTargetLink({link: MEMBERSHIP}));
                setTimeout(() => {
                    history.push(REFRESH_LINK);
                }, 100);
                //history.push(MEMBERSHIP);
            }
        } else {
            dispatch(updateFinalTargetLink({link: QUICK_EDITOR}));
            setTimeout(() => {
				history.push(REFRESH_LINK);
			}, 100);
        }
    }

    const share = () => {
        if(PAID_SERVICES){
            //Bypass plan as pro, pro is free
            if (1 || store.getState().plan == 'pro') {
                popupbox.show('share', null, () => {
                    //do something..
                }, {resume: {...store.getState().resume, id: store.getState().currentResume}, user: store.getState().user, type: 'currentResume', entity:{type: 'resume', name: 'Resume' }})
            }else{
                dispatch(updateFinalTargetLink({link: MEMBERSHIP}));
                setTimeout(() => {
                    history.push(REFRESH_LINK);
                }, 100);
            }
        }else{
            popupbox.show('share', null, () => {
                //do something..
            }, {resume: {...store.getState().resume, id: store.getState().currentResume}, user: store.getState().user, type: 'currentResume', entity:{type: 'resume', name: 'Resume' }})
        }
    }

    const help = () => {
        dispatch(updateFinalTargetLink({link: '/'}));
            setTimeout(() => {
				history.push(REFRESH_LINK);
			}, 100);
        //window.location.href = `${APP_DOMAIN}/${DASHBOARD_LINK}`
    }

    const triggerLastAction = () => {
        const clickAction = (localStorage.getItem('clickAction') && typeof localStorage.getItem('clickAction') != 'undefined' ? localStorage.getItem('clickAction') : '');
        switch (clickAction) {
            case 'download':
                checkMembershipAction(download);
                break;
            case 'print':
                // checkMembershipAction(print);
                // break;
            case 'share':
                checkMembershipAction(share);
                // checkMembershipAction(() => history.push(MEMBERSHIP))
                break;
            case 'saveandnext':
                checkMembershipAction(saveAndNext);
                // checkMembershipAction(() => history.push(MEMBERSHIP))
                break;
            case 'help':
                checkMembershipAction(help);
                break;
            default:
                checkMembershipAction();
                //do nothing..
                break;
        }
    }

    const fullStoryIdentify = (email) => {
        let uId = email;
        let displayName = email;
        // FullStoryIdentify(uId, {
        //   displayName: displayName
        // });
    }

    useEffect(() => {
        if(localStorage.getItem('loginError')){
            const loginError = decryptData(localStorage.getItem('loginError'))
            localStorage.removeItem('loginError')
            setmsg(loginError.msg)
        }
    }, [localStorage.getItem('loginError')])

    const fireGA4EventOnSignup = (msg) => {
        if (msg == 'success') {
            if (props.hasOwnProperty('type') && props.type === 'popup') {
                gaTrack('RT App', `Editor`, `Registered through Popup`);
                ga4Track('app_editor_signup_popup_user_signs_up', 'RT App', 'Registered through Popup');
                ga4Track('app_editor_login_popup_signup', 'RT App', 'Login Popup: Signed up through popup'); 
            }else if(props.hasOwnProperty('type') && props.type === 'coverletter_page') {
                gaTrack('RT App', `Editor`, `Registered through Coverletter`);
                ga4Track('app_signup_user_signs_up', 'RT App', 'Registered through Coverletter');
                ga4Track('app_coverletter_login_signup', 'RT App', 'Login Popup: Signed up through Coverletter'); 
            }else{
                gaTrack('RT App', `Register Page`, 'User Registered');
                ga4Track('app_signup_user_signs_up', 'RT App', 'User Registered');
                ga4Track('app_editor_login_signed_up', 'RT App', 'Login Page: Signed up'); 
            }
            ga4Track('app_all_sign_up_points_user_signup', 'RT App', 'User Signs Up');
        }
    }
    
    return (
        <div className="signup-form">
            <div className="form">
                <div className="field-wrap">
                    {msg && <div className={msg == 'success' ? 'success' : 'error'} style={{marginBottom: "5px"}}>{msg}</div>}
                    <label htmlFor="Email" className="label">Email</label>
                    <input
                        className="form-input borderaccent"
                        type="email"
                        placeholder="Email Address"
                        value={email}
                        onChange={e => setemail(e.target.value)}
                        onKeyDown={e => enter(e)} />
                </div>
                <div className="field-wrap">
                    <label htmlFor="Password" className="label">Password</label>
                    <div className="password-wrap">
                    <input
                        className="form-input borderaccent"
                            type={viewPassword ? 'text' : 'password'}
                        placeholder="Password"
                        value={password}
                        onChange={e => setpassword(e.target.value)}
                        onKeyDown={e => enter(e)} />
                        <span className="password-view" onClick={() => {
                            setViewPassword(!viewPassword);
                        }}><i className={viewPassword ? 'icon-eye-slash' : 'icon-eye'}></i></span>
                    </div>
                </div>
                <div className="field-wrap">
                    <label htmlFor="Password" className="label">Confirm Password</label>
                    <div className="password-wrap">
                    <input
                        className="form-input borderaccent"
                            type={viewConfirmPassword ? 'text' : 'password'}
                        placeholder="Confirm your Password"
                        value={confirmpassword}
                        onChange={e => setconfirmpassword(e.target.value)}
                        onKeyDown={e => enter(e)} />
                        <span className="password-view" onClick={() => {
                            setViewConfirmPassword(!viewConfirmPassword);
                        }}><i className={viewConfirmPassword ? 'icon-eye-slash' : 'icon-eye'}></i></span>
                    </div>
                </div>
                {props?.type !== 'coverletter_page' &&<div className="field-wrap align-right">
                    <button className="button black"
                        id="submit_button"
                        onClick={
                            e => {
                                if (props.hasOwnProperty('type') && props.type === 'popup') {
                                    //Set redirect_to here in case user Sign up through Popup
                                    if(typeof localStorage.getItem('downloadOnAllinonePageLoad') != 'undefined' && !localStorage.getItem('downloadOnAllinonePageLoad'))
                                        WpAPI.setRedirectCookie(window.location.pathname);
                                }
                                removeBodyScroll();
                                if(!validateAndSubmitForm(e)) props?.type == 'coverletter_page' && props?.loginInitiationInturrepted();
                                e.preventDefault()
                            }

                        }>Sign Up</button>
                </div> }
                {/* START: changes for GitLab #950 */}
                {/* <div className="field-wrap">
                    <p className="email-disclaimer">By creating an account, you agree to receive account emails, newsletters, and other promotional emails to the email address provided — unsubscribe anytime.</p>
                </div> */}
                {/* END */}
            </div>
        </div>
    );
}

export default SignupForm;